import { render, staticRenderFns } from "./New_Storage.vue?vue&type=template&id=06c67ad8"
import script from "./New_Storage.vue?vue&type=script&lang=js"
export * from "./New_Storage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports